<template>
    <div v-if="isLoading" class="loader">
        <svg
            viewBox="0 0 100 100"
            preserveAspectRatio="xMidYMid"
            class="ar-loader"
        >
            <rect x="0" y="0" width="100" height="100" fill="none"></rect>
            <circle
                cx="50"
                cy="50"
                r="40"
                stroke="#EFF2F5"
                fill="none"
                stroke-width="8"
                stroke-linecap="round"
            ></circle>
            <circle
                cx="50"
                cy="50"
                r="40"
                stroke="#5b6770"
                fill="none"
                stroke-width="8"
                stroke-linecap="round"
            >
                <animate
                    attributeName="stroke-dashoffset"
                    dur="1.5s"
                    repeatCount="indefinite"
                    from="0"
                    to="502"
                ></animate>
                <animate
                    attributeName="stroke-dasharray"
                    dur="1.5"
                    repeatCount="indefinite"
                    values="150.6 100.4;1 250;150.6 100.4"
                ></animate>
            </circle>
        </svg>
    </div>
</template>

<script>
export default {
    name: "MLoading",
    props: {
        isLoading: {
            type: Boolean,
            default: false
        },
        isFullscreen: {
            type: Boolean,
            default: false
        }
    }
};
</script>
